import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import {
  getToken, getNome, getEmpresa, getIsAdmin,
  getEmpresaId, getEmpresas, limparSessao, salvarSessao,
  trocarEmpresa as trocarEmpresaApi,
} from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [autenticado, setAutenticado] = useState(false);
  const [carregando,  setCarregando]  = useState(true);
  const [nome,        setNome]        = useState('');
  const [empresa,     setEmpresa]     = useState('');
  const [isAdmin,     setIsAdmin]     = useState(false);
  const [empresaId,   setEmpresaId]   = useState(null);
  const [empresas,    setEmpresas]    = useState([]);

  useEffect(() => {
    if (getToken()) {
      setAutenticado(true);
      setNome(getNome() || '');
      setEmpresa(getEmpresa() || '');
      setIsAdmin(getIsAdmin());
      setEmpresaId(getEmpresaId());
      setEmpresas(getEmpresas());
    }
    setCarregando(false);
  }, []);

  const entrar = (n, e, admin = false, empId = null, emps = []) => {
    setAutenticado(true);
    setNome(n);
    setEmpresa(e);
    setIsAdmin(admin);
    setEmpresaId(empId);
    setEmpresas(emps);
  };

  const sair = () => {
    limparSessao();
    setAutenticado(false);
    setNome('');
    setEmpresa('');
    setIsAdmin(false);
    setEmpresaId(null);
    setEmpresas([]);
  };

  const trocarEmpresa = useCallback(async (id) => {
    const data = await trocarEmpresaApi(id);
    // salvarSessao já foi chamado dentro de trocarEmpresaApi
    setEmpresa(data.empresa);
    setEmpresaId(data.empresa_id);
    setEmpresas(data.empresas || []);
    return data;
  }, []);

  return (
    <AuthContext.Provider value={{
      autenticado, carregando,
      nome, empresa, isAdmin,
      empresaId, empresas,
      entrar, sair, trocarEmpresa,
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
